export const isDebugMode = Boolean(process.env.DEBUG);
export const environment = process.env.NODE_ENV;
